import { render, staticRenderFns } from "./editOnboardedCompanyUsersComponent.vue?vue&type=template&id=6d9e223d&"
import script from "./editOnboardedCompanyUsersComponent.vue?vue&type=script&lang=js&"
export * from "./editOnboardedCompanyUsersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports